import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "form"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "form-items cf" }
const _hoisted_4 = { class: "item" }
const _hoisted_5 = { class: "control" }
const _hoisted_6 = {
  class: "label",
  for: "UserName"
}
const _hoisted_7 = { class: "item" }
const _hoisted_8 = {
  class: "control",
  "data-type": "password"
}
const _hoisted_9 = {
  class: "label",
  for: "Password"
}
const _hoisted_10 = {
  key: 0,
  class: "icon fastic-eye-show"
}
const _hoisted_11 = {
  key: 1,
  class: "icon fastic-eye-hide"
}
const _hoisted_12 = {
  class: "form-items",
  "data-type": "privacy"
}
const _hoisted_13 = { class: "item" }
const _hoisted_14 = { class: "checkbox" }
const _hoisted_15 = { for: "RememberMe" }
const _hoisted_16 = { class: "fieldset" }
const _hoisted_17 = {
  key: 0,
  class: "validation-summary-errors"
}
const _hoisted_18 = {
  class: "form-items",
  "data-type": "buttons"
}
const _hoisted_19 = { class: "item calltoaction" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "lable" }
const _hoisted_22 = ["href"]

import { onBeforeMount, ref } from "vue";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountLogin',
  props: {
    returnUrl: {}
  },
  setup(__props: any) {

const props = __props;

const formHelper = FormHelper;
const localizer = Localizer;
const routes = (window as any).App.routes;

const isLoading = ref(false);
const isSuccess = ref(false);
const formData = ref<any>({});
const validationErrors = ref<any[]>([]);
const options = ref<any>(null);
const isLoginVisible = ref(false);
const isHidden = ref(true);

onBeforeMount(async () => {
    options.value = (await Axios.post(routes.Account_GetOptions, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
    isLoginVisible.value = true;
});

async function submitForm() {
    FormHelper.removeFocus();

    validationErrors.value = [];

    isLoading.value = true;

    formData.value.returnUrl = props.returnUrl;

    try {
        await Axios.post(routes.Account_Login, formData.value);

        isSuccess.value = true;

        GTagHelper.sendEvent("form_submit", "account_login");

        window.location.href = props.returnUrl ? props.returnUrl : routes.Home_Home;
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    isLoading.value = false;
}

function isValidationError(controlName: string): boolean {
    return FormHelper.isControlValidationError(controlName, validationErrors.value);
}

function showPasswordIcon() {
    isHidden.value = !isHidden.value;
}

return (_ctx: any,_cache: any) => {
  return (options.value && isLoginVisible.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "item",
          onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(($event: any) => (submitForm()), ["prevent","stop"]), ["enter"]))
        }, [
          _createElementVNode("fieldset", {
            class: "fieldset mrg",
            "data-mrgt": "20",
            disabled: isLoading.value
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("label", _hoisted_6, _toDisplayString(_unref(localizer).get("Account.Common.UserName")), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "UserName",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.userName) = $event)),
                    autocomplete: "email",
                    class: _normalizeClass([{ 'input-validation-error': isValidationError('UserName') }, 'textbox short'])
                  }, null, 2), [
                    [
                      _vModelText,
                      formData.value.userName,
                      void 0,
                      { lazy: true }
                    ]
                  ]),
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(localizer).get("Account.Common.Password")), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    id: "Password",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.password) = $event)),
                    class: _normalizeClass([{ 'input-validation-error': isValidationError('Password') }, 'textbox short'])
                  }, null, 2), [
                    [
                      _vModelText,
                      formData.value.password,
                      void 0,
                      { lazy: true }
                    ]
                  ]),
                  _createElementVNode("button", {
                    class: "show-password short",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(formHelper).showPassword('Password'), showPasswordIcon()))
                  }, [
                    (isHidden.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10))
                      : (_openBlock(), _createElementBlock("span", _hoisted_11))
                  ]),
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "RememberMe",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.RememberMe) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, formData.value.RememberMe]
                  ]),
                  _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(localizer).get("Account.Common.Login_RememberMe")), 1)
                ])
              ])
            ])
          ], 8, _hoisted_2),
          _createElementVNode("fieldset", _hoisted_16, [
            (validationErrors.value.length !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (validationError, index) => {
                      return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(validationError.message), 1))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("button", {
                  id: "ButtonSubmit",
                  class: "button",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (submitForm())),
                  disabled: isLoading.value
                }, [
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(localizer).get("Account.Common.Login_Button")), 1)
                ], 8, _hoisted_20)
              ])
            ]),
            _createElementVNode("a", {
              href: _unref(routes).Account_PasswordRemind,
              class: "link"
            }, _toDisplayString(_unref(localizer).get("Account.Common.Login_ForgotPassword")), 9, _hoisted_22)
          ])
        ], 32)
      ]))
    : _createCommentVNode("", true)
}
}

})